import React from 'react';
import PropTypes from 'prop-types';
import { Range } from 'client/site-modules/shared/components/range/range';

export function YearsSlider({ firstYear, lastYear, currentYear, onChange }) {
  return (
    <div className="years-slider">
      <Range
        min={firstYear}
        max={lastYear}
        step={1}
        selectedMin={currentYear}
        onMinChange={onChange}
        mainColor="#555555"
        hasColorInvertedThumb
        name="year"
        wrapStyles={{ height: '4px' }}
      />
      <div className="d-flex justify-content-between size-14 text-gray-dark">
        <span>{firstYear}</span>
        <span>{lastYear}</span>
      </div>
    </div>
  );
}

YearsSlider.propTypes = {
  firstYear: PropTypes.number.isRequired,
  lastYear: PropTypes.number.isRequired,
  currentYear: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};
